export default [{
    path: '/publicPage/userInsurance',
    name: 'userInsurance',
    component: () => import( /* webpackChunkName: "common" */ './index.vue'),
    meta: {
        authPass: true,
        title: '免除承运方诚意金管理',
        headerId: 'myFortune'
    }
}];